import { getBaseRequest } from '@components/config/axiosClient';
import { getCanonicalSlug, productLink } from '@components/config/helpers';

/**
 * The address of the product whose code is exactly what was searched for ("HT12" goes to HT12), or null when the term is not the code
 * of a product, so the search goes on to the search page as usual. The gateway decides what an exact match is (check-product-term:
 * the case, spaces and dashes do not count, and a product that only matched is not one). Any failure is no match: the search must never
 * be held up, or lost, because this check could not be made.
 *
 * @param {string} term
 * @returns {Promise<string|null>}
 */
export default async function exactProductLink(term) {
    const trimmed = (term || '').trim();
    if (!trimmed) {
        return null;
    }

    try {
        const response = await getBaseRequest(`check-product-term?term=${encodeURIComponent(trimmed)}`);
        const data = response?.data;
        const product = data && data.status === 'success' ? data.product : null;
        const slug = product?.slug || product?.product_slug;
        if (!slug) {
            return null;
        }

        const section = getCanonicalSlug({ canonical_category_slug: product.canonical_category_slug, section_slug: product.section_slug });

        return productLink(section, slug, data.long_term);
    } catch (error) {
        return null;
    }
}
